import React, { useState } from 'react';
import BookingWidget from '../components/BookingWidget';
import { sendContactEmailToBackend } from '../services/backendService';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const result = await sendContactEmailToBackend(formData);

      if (result.success) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setError('Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail.');
      }
    } catch (error) {
      setError('Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section style={{ paddingTop: 'calc(var(--nav-height) + 2rem)' }}>
      <div className="container">
        <h2>Persönlich. Einfach. Auf Augenhöhe.</h2>
        <p>
          Sie möchten ein Anliegen besprechen oder herausfinden, ob FH Consulting zu Ihnen passt? <br />
          Dann lassen Sie uns sprechen – unkompliziert, ehrlich und auf den Punkt. <br />
          Nutzen Sie das Kontaktformular oder buchen Sie direkt einen Termin.
        </p>

        <div className="contact-wrapper">
          {/* Info Column */}
          <div className="contact-info">
            <h3>Wie Sie uns erreichen</h3>

            <h4>📍 Adresse</h4>
            <p>
              Bauernfeindstr. 8<br />
              80939 München
            </p>

            <h4>📞 Telefon</h4>
            <p><a href="tel:+4915292608956">+49 1529 2608956</a></p>

            <h4>✉️ E‑Mail</h4>
            <p><a href="mailto:florian@fh-consulting.de">florian@fh-consulting.de</a></p>

            <h4>🗓️ Was passiert nach Ihrer Nachricht?</h4>
            <ul>
              <li>Wir melden uns werktags innerhalb von 24 Stunden.</li>
              <li>In einem kurzen Gespräch klären wir Ihr Anliegen.</li>
              <li>Wenn es passt, vereinbaren wir ein unverbindliches Beratungsgespräch.</li>
            </ul>
          </div>

          {/* Form Column */}
          <div className="contact-form">
            {submitted && (
              <p style={{ marginBottom: '1rem', color: 'var(--color-primary)' }}>
                Vielen Dank für Ihre Nachricht! Wir melden uns zeitnah bei Ihnen.
              </p>
            )}

            {error && (
              <p style={{
                marginBottom: '1rem',
                color: '#d32f2f',
                backgroundColor: '#ffebee',
                padding: '0.75rem',
                borderRadius: '4px'
              }}>
                {error}
              </p>
            )}

            <form onSubmit={handleSubmit}>
              <label htmlFor="name">Ihr Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Max Mustermann"
                required
              />

              <label htmlFor="email">E‑Mail-Adresse</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="beispiel@domain.de"
                required
              />

              <label htmlFor="subject">Betreff</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Worum geht es?"
                required
              />

              <label htmlFor="message">Ihre Nachricht</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Schildern Sie uns Ihr Anliegen"
                required
              ></textarea>

              <button type="submit" disabled={isLoading}>
                {isLoading ? 'Wird gesendet...' : 'Jetzt Nachricht senden'}
              </button>

              {/* DSGVO Hinweis */}
              <p style={{ fontSize: '0.875rem', color: '#666', marginTop: '1rem' }}>
                Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
                Mehr dazu in unserer <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.
              </p>
            </form>
          </div>
        </div>

        {/* Booking Widget */}
        <div style={{ marginTop: '4rem' }}>
          <h3>Oder buchen Sie direkt Ihren Termin</h3>
          <p>Unverbindlich, kostenlos und direkt planbar:</p>
          <BookingWidget />
        </div>
      </div>
    </section>
  );
}

export default Contact;
